import { render } from "./EditInboundItemsForm.vue?vue&type=template&id=4689c061"
import script from "./EditInboundItemsForm.vue?vue&type=script&lang=js"
export * from "./EditInboundItemsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__